import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

import { ListingReportView } from './report'
import { ListingRemakePanel } from './remake'

type DetailTab = 'report' | 'remake'

const TAB_IDS: Record<DetailTab, string> = {
  report: EID['listing-builder-detail-tab-report'],
  remake: EID['listing-builder-detail-tab-remake'],
}

export function ListingDetailTabs({ jobId }: { jobId: string }) {
  const { t } = useTranslation()
  const [active, setActive] = useState<DetailTab>('report')

  const tabCls = (isActive: boolean) =>
    `px-4 py-2 text-sm font-medium transition-colors ${
      isActive
        ? 'text-orange-500 border-b-2 border-orange-500'
        : 'text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300'
    }`

  return (
    <div>
      <div className="mb-5 flex border-b border-neutral-200 dark:border-neutral-700" role="tablist">
        {(['report', 'remake'] as const).map((tab) => (
          <button
            key={tab}
            id={TAB_IDS[tab]}
            role="tab"
            aria-selected={active === tab}
            aria-controls={`${TAB_IDS[tab]}-panel`}
            onClick={() => setActive(tab)}
            className={tabCls(active === tab)}
          >
            {t(`listingBuilder.detail.tabs.${tab}`)}
          </button>
        ))}
      </div>
      <div role="tabpanel" id={`${TAB_IDS[active]}-panel`} aria-labelledby={TAB_IDS[active]}>
        {active === 'report' ? (
          <ListingReportView jobId={jobId} />
        ) : (
          <ListingRemakePanel jobId={jobId} />
        )}
      </div>
    </div>
  )
}
